export var AppType = {
    ACCOMPLISHMENT_GENERATION: "ACCOMPLISHMENT_GENERATION",
    ACCOMPLISHMENT_CONFIRMATION: "ACCOMPLISHMENT_CONFIRMATION",
    FEEDBACK: "FEEDBACK"
};
export var CodeBranchStatus = {
    ACTIVE: "ACTIVE",
    ARCHIVED: "ARCHIVED"
};
export var CodeContributorType = {
    USER: "USER",
    BOT: "BOT",
    ORGANIZATION: "ORGANIZATION",
    MANNEQUIN: "MANNEQUIN"
};
export var CodeFileChangeType = {
    ADDED: "ADDED",
    MODIFIED: "MODIFIED",
    DELETED: "DELETED",
    RENAMED: "RENAMED",
    COPIED: "COPIED",
    UNCHANGED: "UNCHANGED"
};
export var CodePullRequestStatus = {
    DRAFT: "DRAFT",
    OPEN: "OPEN",
    MERGED: "MERGED",
    CLOSED: "CLOSED"
};
export var CodePullRequestReviewStatus = {
    COMMENTED: "COMMENTED",
    APPROVED: "APPROVED",
    CHANGES_REQUESTED: "CHANGES_REQUESTED",
    DISMISSED: "DISMISSED"
};
export var CompanyStatus = {
    PENDING_SETUP: "PENDING_SETUP",
    ONBOARDING: "ONBOARDING",
    ACTIVE: "ACTIVE"
};
export var OnboardingVersion = {
    BASE: "BASE",
    PULSE: "PULSE"
};
export var CompanyInviteStatus = {
    pending: "pending",
    accepted: "accepted",
    rejected: "rejected",
    cancelled: "cancelled"
};
export var ConversationParticipantType = {
    USER: "USER",
    BOT: "BOT"
};
export var EmployeeAccomplishmentJobStatus = {
    PENDING: "PENDING",
    RUNNING: "RUNNING",
    COMPLETED: "COMPLETED",
    FAILED: "FAILED",
    CANCELLED: "CANCELLED"
};
export var EmployeeAccomplishmentJobSource = {
    MANUAL: "MANUAL",
    AUTO_GENERATED: "AUTO_GENERATED",
    USER_GUIDANCE: "USER_GUIDANCE",
    SUPER_ADMIN: "SUPER_ADMIN",
    WINDY_TASK: "WINDY_TASK"
};
export var EmployeeFeedbackVisibility = {
    MANAGER_ONLY: "MANAGER_ONLY",
    RECIPIENT_AND_MANAGERS: "RECIPIENT_AND_MANAGERS",
    PUBLIC: "PUBLIC"
};
export var EmployeeFeedbackSource = {
    WINDY_INITIATED_FEEDBACK_CHAT: "WINDY_INITIATED_FEEDBACK_CHAT",
    PROACTIVE_FEEDBACK_CHAT: "PROACTIVE_FEEDBACK_CHAT",
    MANUAL_UPLOAD: "MANUAL_UPLOAD"
};
export var EmployeeFeedbackConfidentiality = {
    CONFIDENTIAL: "CONFIDENTIAL",
    MANAGER_HIERARCHY: "MANAGER_HIERARCHY",
    VISIBLE: "VISIBLE"
};
export var EmployeeFeedbackReviewStatus = {
    QUEUED: "QUEUED",
    PENDING_RESPONSE: "PENDING_RESPONSE",
    COMPLETED: "COMPLETED",
    EXPIRED: "EXPIRED"
};
export var EmployeeFeedbackReviewType = {
    MANAGER_REVIEW: "MANAGER_REVIEW"
};
export var EmployeeFeedbackDesiredStatus = {
    PENDING: "PENDING",
    ACTIVE: "ACTIVE",
    FULFILLED: "FULFILLED",
    TARGET_CANCELLED: "TARGET_CANCELLED",
    PROVIDER_DISMISSED: "PROVIDER_DISMISSED",
    REQUESTER_CANCELLED: "REQUESTER_CANCELLED"
};
export var EmployeeRelationshipScore_ConversationMessageType = {
    THREAD: "THREAD",
    MESSAGE: "MESSAGE"
};
export var FeedbackManagerReviewType = {
    REVIEW_ALL: "REVIEW_ALL",
    REVIEW_SENSITIVE: "REVIEW_SENSITIVE",
    REVIEW_NONE: "REVIEW_NONE"
};
export var EmployeePlatformAccess = {
    HAS_ACCESS: "HAS_ACCESS",
    INVITE_PENDING: "INVITE_PENDING",
    NO_ACCESS: "NO_ACCESS"
};
export var SummaryEntityType = {
    ACTIVITY: "ACTIVITY",
    DOCUMENT: "DOCUMENT",
    MEETING: "MEETING",
    TASK: "TASK",
    PR: "PR",
    PR_REVIEW: "PR_REVIEW",
    CONVERSATION: "CONVERSATION"
};
export var FeedItemVisibility = {
    PUBLIC: "PUBLIC",
    PRIVATE: "PRIVATE",
    MANAGER_HIERARCHY: "MANAGER_HIERARCHY",
    EMPLOYEE_AND_MANAGER_HIERARCHY: "EMPLOYEE_AND_MANAGER_HIERARCHY",
    TASK_SESSION_PARTICIPANT: "TASK_SESSION_PARTICIPANT"
};
export var FeedItemType = {
    FEEDBACK: "FEEDBACK",
    ACCOMPLISHMENTS: "ACCOMPLISHMENTS",
    START_DATE: "START_DATE",
    PULSE_RESPONSE: "PULSE_RESPONSE"
};
export var FeedReactionType = {
    EYES: "EYES",
    HEART: "HEART",
    LAUGHING_CRYING: "LAUGHING_CRYING",
    NICELY_DONE: "NICELY_DONE",
    PRAYING: "PRAYING",
    ROCKET: "ROCKET",
    SMILEY: "SMILEY",
    THUMBS_UP: "THUMBS_UP",
    WOW: "WOW"
};
export var IntegrationType = {
    CALENDAR: "CALENDAR",
    CHAT: "CHAT",
    CODE_REPOSITORY: "CODE_REPOSITORY",
    CRM: "CRM",
    CUSTOMER_SUPPORT: "CUSTOMER_SUPPORT",
    DESIGN: "DESIGN",
    DOCUMENT_MANAGEMENT: "DOCUMENT_MANAGEMENT",
    EMAIL: "EMAIL",
    HRIS: "HRIS",
    MEETING: "MEETING",
    PROJECT_MANAGEMENT: "PROJECT_MANAGEMENT",
    RECORDING: "RECORDING",
    VIRTUAL_OFFICE: "VIRTUAL_OFFICE"
};
export var InstallationAccessTokenType = {
    oauth: "oauth",
    personal_access_token: "personal_access_token",
    merge_dev: "merge_dev"
};
export var IntegrationInstallationStatus = {
    pending_configuration: "pending_configuration",
    active: "active",
    archived: "archived",
    warning: "warning",
    error: "error",
    demo: "demo"
};
export var IntegrationInstallationSyncJobStatus = {
    pending: "pending",
    running: "running",
    success: "success",
    failed: "failed"
};
export var IntegrationUserExternalStatus = {
    ACTIVE: "ACTIVE",
    DELETED: "DELETED"
};
export var IntegrationUserExternalType = {
    USER: "USER",
    BOT: "BOT",
    OTHER: "OTHER"
};
export var MeetingAttendeeType = {
    INTERNAL: "INTERNAL",
    EXTERNAL: "EXTERNAL",
    BOT: "BOT"
};
export var ReportType = {
    DEEP_DIVE: "DEEP_DIVE",
    TEMPLATED_RESEARCH: "TEMPLATED_RESEARCH",
    WINDY_PULSE: "WINDY_PULSE",
    ACCOMPLISHMENTS_TEAM_REVIEW: "ACCOMPLISHMENTS_TEAM_REVIEW",
    FEEDBACK_RECEIVED: "FEEDBACK_RECEIVED",
    TEAM_FEEDBACK_RECEIVED: "TEAM_FEEDBACK_RECEIVED"
};
export var ReportStatus = {
    PENDING: "PENDING",
    IN_PROGRESS: "IN_PROGRESS",
    COMPLETED: "COMPLETED",
    FAILED: "FAILED"
};
export var ResearchPipelineRunStatus = {
    PENDING: "PENDING",
    IN_PROGRESS: "IN_PROGRESS",
    COMPLETED: "COMPLETED",
    FAILED: "FAILED",
    TERMINATED: "TERMINATED"
};
export var ResearchDeepDiveRating = {
    POSITIVE: "POSITIVE",
    NEGATIVE: "NEGATIVE"
};
export var RoamDemoJobStatus = {
    PENDING: "PENDING",
    RUNNING: "RUNNING",
    COMPLETED: "COMPLETED",
    FAILED: "FAILED"
};
export var RoamDemoSessionType = {
    PROACTIVE: "PROACTIVE",
    REACTIVE: "REACTIVE"
};
export var ScheduledMeetingType = {
    unknown: "unknown",
    internal: "internal",
    external: "external",
    ooo: "ooo"
};
export var ScheduledMeetingAtteendeeRSVPStatus = {
    declined: "declined",
    accepted: "accepted",
    tentative: "tentative",
    awaiting_reply: "awaiting_reply",
    unknown: "unknown"
};
export var AlertType = {
    WEEKLY_ROUNDUP: "WEEKLY_ROUNDUP",
    DAILY_FEEDBACK_SUMMARY: "DAILY_FEEDBACK_SUMMARY",
    DAILY_KEY_EVENTS: "DAILY_KEY_EVENTS",
    METRIC_ANOMALY_ALERT: "METRIC_ANOMALY_ALERT",
    TEAM_WEEKLY_REPORT: "TEAM_WEEKLY_REPORT",
    TEAM_DAILY_SCHEDULE: "TEAM_DAILY_SCHEDULE"
};
export var AnalyticsReportStatus = {
    PENDING: "PENDING",
    PROCESSING: "PROCESSING",
    COMPLETE: "COMPLETE",
    FAILED: "FAILED"
};
export var AnalyticsReportRowStatus = {
    PENDING: "PENDING",
    PROCESSING: "PROCESSING",
    COMPLETE: "COMPLETE",
    FAILED: "FAILED"
};
export var ChannelOrgCreationType = {
    auto: "auto",
    manual: "manual"
};
export var EmailSendProvider = {
    resend: "resend",
    mock: "mock"
};
export var StatValueType = {
    COUNT: "COUNT",
    AGGREGATE: "AGGREGATE",
    AVERAGE: "AVERAGE"
};
export var TimeOffType = {
    VACATION: "VACATION",
    SICK: "SICK",
    PERSONAL: "PERSONAL",
    JURY_DUTY: "JURY_DUTY",
    VOLUNTEER: "VOLUNTEER",
    BEREAVEMENT: "BEREAVEMENT",
    UNKNOWN: "UNKNOWN"
};
export var FeatureFlagOverrideStatus = {
    enabled: "enabled",
    disabled: "disabled",
    not_set: "not_set"
};
export var NotificationChannelType = {
    EMAIL: "EMAIL",
    SMS: "SMS",
    SLACK: "SLACK",
    ROAM: "ROAM"
};
export var RecordingType = {
    unknown: "unknown",
    internal: "internal",
    external: "external"
};
export var MeetingProvider = {
    ZOOM: "ZOOM",
    GOOGLE: "GOOGLE",
    ROAM: "ROAM"
};
export var RefuelRequestEntityType = {
    CALENDAR_EVENT: "CALENDAR_EVENT",
    MEETING: "MEETING",
    EMPLOYEE_RELATIONSHIP: "EMPLOYEE_RELATIONSHIP",
    FEEDBACK: "FEEDBACK",
    WINDY_FEEDBACK_CHAT: "WINDY_FEEDBACK_CHAT"
};
export var SmsProvider = {
    TWILIO: "TWILIO",
    MOCK: "MOCK"
};
export var UserSource = {
    email: "email",
    google: "google",
    github: "github",
    microsoft: "microsoft"
};
export var SystemTheme = {
    LIGHT: "LIGHT",
    DARK: "DARK"
};
export var ShoutoutStatus = {
    PENDING: "PENDING",
    PROCESSING: "PROCESSING",
    APPROVED: "APPROVED",
    AUTO_APPROVED: "AUTO_APPROVED",
    REJECTED: "REJECTED"
};
export var WindyTaskType = {
    ACCOMPLISHMENTS: "ACCOMPLISHMENTS",
    EMPLOYEE_FEEDBACK: "EMPLOYEE_FEEDBACK",
    SCHEDULED_REPORT: "SCHEDULED_REPORT",
    PULSE: "PULSE"
};
export var WindyTaskDisplayType = {
    ACCOMPLISHMENTS: "ACCOMPLISHMENTS",
    EMPLOYEE_FEEDBACK: "EMPLOYEE_FEEDBACK",
    PULSE: "PULSE",
    BLOCKERS: "BLOCKERS",
    RETRO: "RETRO",
    MEETING_AGENDA: "MEETING_AGENDA",
    NEW_HIRE_ONBOARDING: "NEW_HIRE_ONBOARDING",
    ONE_ON_ONE: "ONE_ON_ONE",
    GOALS: "GOALS",
    STANDUP: "STANDUP",
    MEETING_FEEDBACK: "MEETING_FEEDBACK",
    PRIORITIES: "PRIORITIES",
    INTERVIEW_FEEDBACK: "INTERVIEW_FEEDBACK",
    SCHEDULED_REPORT: "SCHEDULED_REPORT"
};
export var WindyTaskStatus = {
    ACTIVE: "ACTIVE",
    PAUSED: "PAUSED",
    ARCHIVED: "ARCHIVED",
    COMPLETED: "COMPLETED"
};
export var WindyTaskAnonymity = {
    ANONYMOUS: "ANONYMOUS",
    MANAGER_HIERARCHY: "MANAGER_HIERARCHY",
    NAMED: "NAMED"
};
export var WindyTaskVisibility = {
    PUBLIC: "PUBLIC",
    PRIVATE: "PRIVATE",
    MANAGER_HIERARCHY: "MANAGER_HIERARCHY",
    EMPLOYEE_AND_MANAGER_HIERARCHY: "EMPLOYEE_AND_MANAGER_HIERARCHY",
    PARTICIPANTS: "PARTICIPANTS"
};
export var WindyTaskSessionType = {
    REGULAR: "REGULAR",
    TEST: "TEST"
};
export var WindyTaskReportType = {
    SINGLE_SESSION: "SINGLE_SESSION",
    MULTI_SESSION: "MULTI_SESSION"
};
export var WindyAccomplishmentsTaskChatOutcome = {
    NO_CHANGES: "NO_CHANGES",
    TWEAKS: "TWEAKS",
    REWRITE: "REWRITE"
};
export var WindyEmployeeFeedbackTaskFrequency = {
    TWICE_WEEKLY: "TWICE_WEEKLY",
    WEEKLY: "WEEKLY",
    EVERY_TWO_WEEKS: "EVERY_TWO_WEEKS",
    MONTHLY: "MONTHLY"
};
export var WindyEmployeeFeedbackTaskCandidateStatus = {
    PENDING: "PENDING",
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
    EXPIRED: "EXPIRED"
};
export var WindyEmployeeFeedbackTaskCandidateRequestStatus = {
    PENDING: "PENDING",
    SELECTED: "SELECTED",
    REJECTED: "REJECTED",
    EXPIRED: "EXPIRED"
};
export var WindyEmployeeFeedbackTaskReportType = {
    FEEDBACK_RECEIVED: "FEEDBACK_RECEIVED",
    TEAM_FEEDBACK_RECEIVED: "TEAM_FEEDBACK_RECEIVED"
};
export var WindyChatAgent = {
    ACCOMPLISHMENTS: "ACCOMPLISHMENTS",
    AD_HOC: "AD_HOC",
    DEEP_DIVE: "DEEP_DIVE",
    DESIRED_FEEDBACK: "DESIRED_FEEDBACK",
    INTEGRATIONS: "INTEGRATIONS",
    PROACTIVE_FEEDBACK: "PROACTIVE_FEEDBACK",
    WINDY: "WINDY",
    DISPATCH: "DISPATCH"
};
export var WindyChatType = {
    ACCOMPLISHMENT_CONFIRMATION: "ACCOMPLISHMENT_CONFIRMATION",
    ACCOMPLISHMENT_TEAM_REVIEW: "ACCOMPLISHMENT_TEAM_REVIEW",
    EMPLOYEE_FEEDBACK: "EMPLOYEE_FEEDBACK",
    FEEDBACK_MANAGER_REVIEW: "FEEDBACK_MANAGER_REVIEW",
    FEEDBACK_DELIVERY: "FEEDBACK_DELIVERY",
    ACCOUNT_ONBOARDING: "ACCOUNT_ONBOARDING",
    ACCOUNT_ONBOARDING_PULSE: "ACCOUNT_ONBOARDING_PULSE",
    EMPLOYEE_ONBOARDING: "EMPLOYEE_ONBOARDING",
    EMPLOYEE_NUDGE: "EMPLOYEE_NUDGE",
    NEW_YEARS_FEEDBACK_2024: "NEW_YEARS_FEEDBACK_2024",
    MARQII_RKO_DAY_2: "MARQII_RKO_DAY_2",
    MARQII_RKO_WRAP_UP: "MARQII_RKO_WRAP_UP",
    AD_HOC_SESSION: "AD_HOC_SESSION",
    AD_HOC_AGENTIC_SESSION: "AD_HOC_AGENTIC_SESSION",
    PULSE: "PULSE",
    TASK_SESSION_UPDATE: "TASK_SESSION_UPDATE",
    WINDY: "WINDY",
    SWITCHBOARD: "SWITCHBOARD"
};
export var WindyChatChannel = {
    SLACK: "SLACK",
    ROAM: "ROAM"
};
export var WindyChatMessageSender = {
    USER: "USER",
    BOT: "BOT",
    NOTIFICATION: "NOTIFICATION",
    AUTOMATED: "AUTOMATED"
};
export var WindyChatSentiment = {
    SATISFACTION: "SATISFACTION",
    ENTHUSIASM: "ENTHUSIASM",
    NEUTRAL: "NEUTRAL",
    TROLL: "TROLL",
    FRUSTRATION: "FRUSTRATION",
    CONFUSION: "CONFUSION",
    MISSING_FEATURE: "MISSING_FEATURE"
};
export var WindyChatMessageStatus = {
    PENDING_APPROVAL: "PENDING_APPROVAL",
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
    AUTO_APPROVED: "AUTO_APPROVED"
};
export var WindyMessageAction = {
    FEEDBACK_MANAGER_REVIEW_MANAGER_HANDLE: "FEEDBACK_MANAGER_REVIEW_MANAGER_HANDLE",
    FEEDBACK_MANAGER_REVIEW_WINDY_HANDLE: "FEEDBACK_MANAGER_REVIEW_WINDY_HANDLE"
};
export var WindyFeedbackChatStatus = {
    PENDING_APPROVAL: "PENDING_APPROVAL",
    ACTIVE: "ACTIVE",
    COMPLETE: "COMPLETE",
    DISMISSED: "DISMISSED",
    EXPIRED: "EXPIRED",
    CANCELLED: "CANCELLED",
    REJECTED: "REJECTED"
};
export var WindyFeedbackChatSource = {
    MANUAL: "MANUAL",
    AUTO: "AUTO",
    ADMIN: "ADMIN"
};
export var WindyFeedbackManagerReviewStatus = {
    PENDING: "PENDING",
    MANAGER_HANDLE: "MANAGER_HANDLE",
    WINDY_HANDLE: "WINDY_HANDLE"
};
export var WindyChatNotificationType = {
    FIRST_REMINDER: "FIRST_REMINDER",
    SECOND_REMINDER: "SECOND_REMINDER",
    DEADLINE_REMINDER: "DEADLINE_REMINDER",
    MANUAL: "MANUAL",
    TASK_SESSION_UPDATE_FIRST_RESPONSE_RECEIVED: "TASK_SESSION_UPDATE_FIRST_RESPONSE_RECEIVED",
    TASK_SESSION_UPDATE_ONE_DAY_UPDATE: "TASK_SESSION_UPDATE_ONE_DAY_UPDATE",
    TASK_SESSION_UPDATE_NEW_RESPONSES_DAILY: "TASK_SESSION_UPDATE_NEW_RESPONSES_DAILY",
    TASK_SESSION_UPDATE_DEADLINE_PASSED: "TASK_SESSION_UPDATE_DEADLINE_PASSED"
};
